import { P2GGrid, P2GTextField } from '@parcel2go/core-ui';
import { useTaxName } from '@parcel2go/npm-p2g-app';
import { useTranslation } from 'react-i18next';
import { InputRuleApiModel } from '~/lib/api/smartsend/types';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  onChange?: (id: string, value: string) => void;
  value: string;
  id: string;
  required?: boolean;
  validation: InputRuleApiModel[];
  xs?: boolean | 'auto' | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  sm?: boolean | 'auto' | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  md?: boolean | 'auto' | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  lg?: boolean | 'auto' | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  xl?: boolean | 'auto' | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  gridItem?: boolean;
  translationKey: string;
  isConditionalRequired?: (m: InputRuleApiModel) => boolean;
}

export const MetaInputRow: React.FC<props> = (props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const taxName = useTaxName();

  const m = props.validation.find((x) => x.name === props.id);
  if (!m) {
    return null;
  }

  const translationLabel = t(props.translationKey, { taxName, defaultValue: m.label });

  if (!props.gridItem) {
    return (
      <P2GTextField
        fullWidth
        {...m}
        label={translationLabel}
        value={props.value}
        onChange={(v) => props.onChange(props.id, v.currentTarget.value)}
        id={props.id}
        required={
          props.isConditionalRequired
            ? (props.isConditionalRequired(m) ?? props.required ?? m.required)
            : (props.required ?? m.required)
        }
      />
    );
  }

  return (
    <P2GGrid item xs={props.xs} sm={props.sm} md={props.md} lg={props.lg} xl={props.xl}>
      <P2GTextField
        fullWidth
        {...m}
        label={translationLabel}
        value={props.value}
        onChange={(v) => props.onChange(props.id, v.currentTarget.value)}
        id={props.id}
        required={
          props.isConditionalRequired
            ? (props.isConditionalRequired(m) ?? props.required ?? m.required)
            : (props.required ?? m.required)
        }
      />
    </P2GGrid>
  );
};
